<template>
    <div class="ClassStylewarp">
        <div class="menubox">
            <div v-for="(item,index) in menubox" :key="index" :class="activename==item.name?'activeitembox':'nameitembox'" @click="changemenu(item)">
                <span class="name">{{item.name}}</span>
                <span class="line"></span>
            </div>
        </div>
        <!-- <div class="rightMore" @click="gonewsecond">
            <span class="morebox">
                更多
                <i class="el-icon-caret-right"></i>
            </span>
        </div> -->
        <div class="datapageBox">
            <div v-if="activename=='教学活动'">
                <Page1/>
            </div>
            <div v-if="activename=='企业参访'">
                <Page2/>
            </div>
            <div v-if="activename=='供需对接'">
                <Page3/>
            </div>
            <div v-if="activename=='论坛'">
                <Page4/>
            </div>
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import Page1 from './components/page1'
import Page2 from './components/page2'
import Page3 from './components/page3'
import Page4 from './components/page4'
export default {
    components: {
        Page1,
        Page2,
        Page3,
        Page4
    },
    data() {
        return {
            srcUrl: srcUrl,
            activename: '教学活动',
            menubox: [
                { name: '教学活动' },
                { name: '企业参访' },
                { name: '供需对接' },
                { name: '论坛' },
            ]

        }
    },
    mounted() {

    },
    methods: {
        changemenu(item) {
            this.activename = item.name
        },
        // 更多页面
        

    },
}
</script>
<style lang="less" scoped>
.ClassStylewarp {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	.menubox {
		display: flex;
		flex-direction: row;
		justify-content: center;
        text-align: center;
		// align-items: center;
		font-size: 20px;
		// line-height: 35px;
        margin-bottom: 16px;
		.nameitembox {
			color: #999999;
			cursor: pointer;
            text-align: center;
			&:last-child {
                width: 44px;
				.line {
					height: 0;
				}
			}
		}
		.activeitembox {
			color: #448df7;
			cursor: pointer;
            text-align: center;
			&:last-child {
                width: 44px;
				.line {
					height: 0;
				}
			}
		}
		.line {
			display: inline-block;
			width: 1px;
			height: 16px;
			background: #c2c2c2;
			margin: 0 48px;
		}
	}
}
</style>


